<!-- =========================================================================================
   File Name: UserEditTabInformation.vue
   Description: User Edit Information Tab content
   ----------------------------------------------------------------------------------------
   Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
   Author: Pixinvent
   Author URL: http://www.themeforest.net/user/pixinvent
   ========================================================================================== -->
<style lang="scss" scoped>
  
  
   .outfit {
   line-height: 0;
   position: relative;
   width: auto;
   height: auto;
   background: gray;
   display: inline-block;
    img {
    width: 100%;
    height: auto;
    cursor: pointer;
    }
   }
   .dot {
   position: absolute;
   width: 24px;
   height: 24px;
   background: rgba(white, 1);
   border-radius: 50%;
   cursor: pointer;
   box-shadow: 0 0 3px 0 rgba(0, 0, 0, .2);
   line-height: 24px;
   font-size: 12px;
   font-weight: bold;
   transition: .2s;
   z-index: 9999;
   &.ui-draggable-dragging {
   box-shadow: 0 0 25px 0 rgba(0, 0, 0, .5);
   transform: scale3d(1.2, 1.2, 1.2);
   background: rgba(white, .7);
   }
   }

  
   .image-output{width: 100%; height: auto; border: 1px solid #dfdfdf; border-radius: 5px; display: flex; justify-content: center; align-items: center;overflow: hidden;}
   .image-output img{width: 100%;height: auto !important}
   .customhtml-backgroundclr-wrap{display: flex; justify-content: space-between; align-items: center;}
   .musicPath .vs-component {
   padding-right: 82px;
   }
   .upload-files span {
   padding: 9px 13px;
   background: #4c8af6;
   color: #fff;
   border-radius: 3px;
   cursor: pointer;
   }
   ul.tabs{
   margin: 0px;
   padding: 0px;
   list-style: none;
   }
   ul.tabs li{
   background: none;
   color: #222;
   display: inline-block;
   padding: 10px 15px;
   cursor: pointer;
   }
   ul.tabs li.current{
   background: #ededed;
   color: #222;
   }
   .tab-content{
   display: none;
   background: #ededed;
   padding: 15px;
   }
   .tab-content.current{
   display: inherit;
   }
  
  
   .upload-wrap {
   display: flex;
   justify-content: space-between;
   align-items: center;
   }
   .text-editor-wrap {
   height: 800px;
   width: 100%;
   border: 1px solid #929292;
   overflow-y: scroll;
   }

.upload-files input {
  display: none;
}
.upload-files span {
  padding: 9px 13px;
  background: #4c8af6;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
.flie-btn{position: relative !important; top: 0; right: 0; }
.bg-img-path .upload-wrap .vs-component{padding-left: 0 !important; padding-right: 0 !important;}
.my-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
  }
.prism-editor__textarea:focus {
  outline: none;
  }
  .lobbyToggle{
    right: 0;
    left:0;
    display: flex;
    white-space: nowrap;
    position: absolute;
    justify-content: flex-end;
    padding-bottom: 14px;
    box-shadow: 0 0 25px 0 rgba(0,0,0,.04);
    top: 1px;
    border-radius: 10px 10px 0 0;
    padding:15px 20px;
  }
  .lobbyToggle button{
    margin-left:10px;
  }  
    .lobbtTagText{
    min-width:172px;
    text-align:right;
  }
  .on-off-music, .hotspot-on-off {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
  }
  .hotspot-number ul li a img {
    height: 15px;
    width: 15px;
}
</style>
<template>
   <div id="user-edit-tab-info" class="mt-0">
      <div class="vx-row">
         <div class="vx-col md:w-3/12 w-full">
            <v-select placeholder="Select Template" v-model="selected" :options="templateNames"  v-on:input="selectTemplate()"/>
         </div>
         <div class="vx-col md:w-1/1 w-full mt-5">
            <ul class="tabs">
               <li class="tab-link current" data-tab="tab-1">Visual Editor</li>
               <li class="tab-link" data-tab="tab-2" v-on:click="fetchCodeValue">Code Editor</li>
            </ul>
            <div id="tab-1" class="tab-content current">
               <div class="output-area mt-4">
                  <div class="vx-row">
                     <div class="vx-col md:w-9/12 w-full">
                        <label>Preview</label>
                          <div class="outfit"><img :src="imageUrl" /></div>
                     </div>
                     <div class="vx-col md:w-3/12 w-full mt-5">
                        <div class="hotspot-number">
                           <ul v-for="spot in total" :key="spot.id">
                              <li>{{spot.id}} <small style="font-size: 12px">{{spot.value}}</small><a v-on:click="removeHotspot(spot.id)">
                                <img src="../../assets/images/trash-bin.svg"/></a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <a class="pt-5" v-if="showValues !=null" :href="local_data[showValues].SourcePSDfile" download>Download PSD</a>
                  <div class="vx-row">
                     <div class="vx-col md:w-3/12 w-full mt-5">
                        <label>Select url</label>
            <v-select placeholder="Choose a Url" :options="menuUrls" :reduce="value => value.value" label="key" append-to-body :calculate-position="withPopper" v-model="urlValue" v-on:input="selectPageUrl()"/>
                     </div>
                     <div class="vx-col md:w-3/12 w-full mt-5" v-if="urlValue == 'Custom URL'">
                        <label>Add Embed code or URL</label>
                        <vs-input class="inputx w-full" v-model="titleValue" v-on:change="addTitle"/>
                     </div>
                    <div class="vx-col md:w-3/12 w-full mt-5" v-else>
                        <label>Add Title</label>
                        <vs-input class="inputx w-full" v-model="titleValue" v-on:change="addTitle"/>
                     </div>
                    <div class="vx-col md:w-3/12 w-full mt-5">
                      <div class="bg-img-path">
                        <label>Upload Background Image</label>
                        <div class="upload-wrap">
                            <vs-input
                              class="inputx w-full"
                              name="bgImagePath"
                              v-model="imageUrl"
                            />
                            <label class="upload-files flie-btn">
                            <input
                              type="file"
                              ref="lobbyBgUpload_input"
                              @change="lobbyBgUpload($event, 'bgImagePath', 'imgSrc')"
                              accept="image/*"
                            />
                            <span>Upload</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col md:w-3/12 w-full mt-5">
                      <div class="hotspot-on-off">
                        <label>On / Off Hotspot</label>
                        <vs-switch v-model="displayHotspotFlg" v-on:click="onHotspotToogleChange"/>
                      </div>
                    </div>
                  </div>
               </div>
            </div>
            <div id="tab-2" class="tab-content">
               <label>Custom HTML</label>
               <div class="text-editor-wrap">
                 <prism-editor class="my-editor" v-model="code" :highlight="highlighter" line-numbers></prism-editor>
               </div>
               <div class="vx-row">
                  <div class="vx-col md:w-6/12 w-full mt-4">
                     <label>Upload Background Music</label>
                     <div class="musicPath">
                        <vs-input
                           class="inputx w-full mt-2"
                           name="MusicURL"
                           v-model="musicFileUrl"
                           />
                        <label class="upload-files">
                        <input type="file" accept="audio/*" @change="uploadMP3file" />
                        <span>Upload</span>
                        </label>
                        <span class="text-danger text-sm" v-show="errors.has('MusicURL')">{{
                        errors.first("MusicURL")
                        }}</span>
                     </div>
                     <a href="javascript:void(0)" @click="resetMusicLink">Reset Music</a>
                  </div>
                  <div class="vx-col md:w-3/12 w-full mt-4">
                    <div class="on-off-music">
                      <label>ON/OFF Music</label>
                      <vs-switch v-model="musicType"  v-on:click="onMusicToogleChange"/>
                    </div>
                  </div>
                     <div class="vx-col md:w-3/12 w-full mt-4">
                    <div class="on-off-music">
                      <label>ON/OFF Mouse Cursor Icon</label>
                      <vs-switch v-model="mouseCursorType"  v-on:click="onMouseCursorToogleChange"/>
                    </div>
                  </div>
                  <!-- <div class="vx-col md:w-3/12 w-full mt-4">
                    <div class="on-off-music reset-music">
                      <label>Reset Music</label>
                      <vs-switch v-model="switch2" />
                    </div>
                  </div> -->
               </div>
            </div>
         </div>
      </div>
      <!-- Save & Reset Button -->
      <div class="vx-row">
         <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
               <vs-button class="ml-auto mt-2" @click="before_save">Save Changes</vs-button>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
   import $ from "jquery";
   import 'jquery-ui-dist/jquery-ui';
   import firebase from 'firebase';
   import con from '@/firebase/firebaseInit.ts'
   import vSelect from 'vue-select'
   import 'quill/dist/quill.snow.css'
   import { quillEditor } from 'vue-quill-editor'
   import flatPickr from 'vue-flatpickr-component';
   import 'flatpickr/dist/flatpickr.css';
   import ls from "@/common/localStorage"
   import moduleVirtualLobbyManagement from "@/store/virtuallobby-management/moduleVirtuallobbyManagement.js";
   import { createPopper } from '@popperjs/core';
   import { PrismEditor } from 'vue-prism-editor';
  import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

  // import highlighting library (you can use any library you want just return html string)
  import { highlight, languages } from 'prismjs/components/prism-core';
  import 'prismjs/components/prism-clike';
  import 'prismjs/components/prism-javascript';
  import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles
  import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
   var vm;
   var cn = ls.getSessionEventCollectionName();
   const virtuallobbyRef = con.eventDB.collection(cn).doc('VirtualLobby');
   var hotspotNumber = [];
   var hotspotFlag = false;
   var latestSpotVal = null;
   export default {
     components: {
       vSelect,
       quillEditor,
       'v-select': vSelect,
       flatPickr,
       PrismEditor
     },
     data () {
       return {
         selected: null,
         templateNames: [],
         local_data: [],
         showValues:null,
         musicFileUrl:null,
         templateHTML: null,
         sendData:[],
         musicFile: null,
         menuUrls: [],
         total:hotspotNumber,
         urlValue: null,
         code: null,
         imageUrl: null,
         titleValue: null,
         embedValue: null,
         musicType: false,
         isImageUploaded: false,
         displayHotspotFlg: true,
         defaultMusicUrl: "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/Sounds%2Flobby_1234567890.mp3?alt=media",
         mouseCursorType: false,
       }
     },
     methods: {
       resetMusicLink(){
          this.sendData = [];
          this.sendData.MusicURL = this.defaultMusicUrl;
          this.musicFileUrl = this.defaultMusicUrl;
          this.$vs.loading();
          this.$store
           .dispatch("virtuallobbyManagement/updateVirtuallobbyImageHotspot", {
             data: this.sendData,
           })
           .then((res) => {
             if (res.status == 200) {
                 this.$vs.notify({
                 color: "success",
                 position: "top-center",
                 title: "Virtual Lobby",
                 text: "Updated Successfully!",
               });
               this.$vs.loading.close();
             }
           })
           .catch((err) => {
             this.$vs.loading.close();
           });
       },
       onMusicToogleChange(){
         this.sendData = [];
        this.sendData.IsMusicEnable = !this.musicType;
        this.$store
           .dispatch("virtuallobbyManagement/updateVirtuallobbyImageHotspot", {
             data: this.sendData,
           })
           .then((res) => {
             if (res.status == 200) {
                 this.$vs.notify({
                 color: "success",
                 position: "top-center",
                 title: "Virtual Lobby",
                 text: "Updated Successfully!",
               });
               this.$vs.loading.close();
             }
           })
           .catch((err) => {
             this.$vs.loading.close();
           });

       },
        onMouseCursorToogleChange(){
         this.sendData = [];
          this.sendData.IsMouseCursorEnable = !this.mouseCursorType;
        this.$store
           .dispatch("virtuallobbyManagement/updateVirtuallobbyImageHotspot", {
             data: this.sendData,
           })
           .then((res) => {
             if (res.status == 200) {
                 this.$vs.notify({
                 color: "success",
                 position: "top-center",
                 title: "Virtual Lobby",
                 text: "Updated Successfully!",
               });
               this.$vs.loading.close();
             }
           })
           .catch((err) => {
             this.$vs.loading.close();
           });

       },
       onHotspotToogleChange(){
        this.sendData = [];
        this.sendData.IsHotspotEnable = !this.displayHotspotFlg;
        this.$store
           .dispatch("virtuallobbyManagement/updateVirtuallobbyImageHotspot", {
             data: this.sendData,
           })
           .then((res) => {
             if (res.status == 200) {
                 this.$vs.notify({
                 color: "success",
                 position: "top-center",
                 title: "Virtual Lobby",
                 text: "Updated Successfully!",
               });
               this.$vs.loading.close();
             }
           })
           .catch((err) => {
             this.$vs.loading.close();
           });
       },
       fetchCodeValue(){
         if(this.isImageUploaded == true){
                    if(this.imageUrl != null){
            this.code='<img src="'+this.imageUrl + '" style="height:100vh;"/>';
         }
       
         if(hotspotNumber.length > 0){
            hotspotNumber.map((row1) => {
              if(row1.value == "Custom URL"){
           this.code += '<a class="dot" href="'+ row1.title  + '" style="position: absolute;left:'+row1.left+'%;top:'+row1.top+'%;z-index: 2;width: 5%; height: 8%"></a> ';
              }else{
            var title = row1.title == undefined ? '' : row1.title;
           this.code += '<a class="dot" href="'+ row1.value +'" title="'+ title  + '" style="position: absolute;left:'+row1.left+'%;top:'+row1.top+'%;z-index: 2;width: 5%; height: 8%"></a> ';
              }

       });
         }

        //    if(this.embedValue != null){
        //    this.code += this.embedValue;
        //  }

         }
       },
      highlighter(code) {
        return highlight(code, languages.js); // languages.<insert language> to return html with markup
      },
       removeHotspot(id){
       var elements = document.querySelectorAll('.dot');  
       hotspotFlag = false;
       for (var element of elements) {
         if(element.id == id){
         element.parentNode.removeChild(element);
         hotspotNumber = hotspotNumber.filter(function(item) {
           return item.id !== id
         })
         this.total = hotspotNumber;
         }
   }
},
addTitle:function(type){
        hotspotNumber.map((row) => {
         if(row.id == latestSpotVal){
           row.title = this.titleValue;
         }
       });
       //this.urlValue = null;
         this.urlValue = null
         this.titleValue = null;
       hotspotFlag = false;
       },
       selectPageUrl(){
       hotspotNumber.map((row) => {
         if(row.id == latestSpotVal){
           row.value = this.urlValue;
         }
       });
       //this.urlValue = null;
       //hotspotFlag = false;
       },
       fetchVirtualTemplates(){
         this.$store
           .dispatch("virtuallobbyManagement/fetchVirtualLobbyTemplates")
           .then(res => {
             res.data.map(row =>{ 
            this.templateNames.push(row.TemplateName);
            });
            this.local_data = res.data;
            })
           .catch(err => {
             console.error(err);
           });
       },
       
       selectTemplate(){
         if(this.selected == "Custom Lobby - Style 1"){
           this.showValues = 0;
           this.templateHTML = null;
           this.imageUrl = this.local_data[this.showValues].TemplateImage;
           this.code = this.local_data[this.showValues].TemplateHTML;
         }else if(this.selected == "Custom Lobby - Style 2"){
           this.showValues = 1;
           this.templateHTML = null;
           this.imageUrl = this.local_data[this.showValues].TemplateImage;
           this.code = this.local_data[this.showValues].TemplateHTML;
         }else if(this.selected == "Custom Lobby - Style 3"){
           this.showValues = 2;
           this.templateHTML = null;
           this.imageUrl = this.local_data[this.showValues].TemplateImage;
           this.code = this.local_data[this.showValues].TemplateHTML;
         }else{
           this.showValues = null;
         }
       },
       uploadMP3file(input) {
         // You can update avatar Here
         this.musicFileUrl = null;
         if (input.target.files && input.target.files[0]) {
           const musicfile = input.target.files[0];
           const metadata = { contentType: musicfile.type };
           const validFileTypes = ["audio/mp3", "audio/mpeg"];
           if (!validFileTypes.includes(musicfile.type)) {
             alert("Only mp3 file allowed.");
             return false;
           }
           if (musicfile.size > 15728640) {
             //max 15 MB file Size
             alert("File too big (> 15MB)");
             return false;
           }
           this.musicFile = musicfile;
           const reader = new FileReader();
           reader.onload = (e) => {
             //this.mp3File = e.target.result
           };
           this.musicFileUrl = musicfile.name;
           console.log("url========",this.musicFileUrl);
           reader.readAsDataURL(input.target.files[0]);
         }
       },
       fetch_virtuallobby_data () {
         this.$store.dispatch('virtuallobbyManagement/fetchVirtualLobbySettings')
           .then(res => { 
            this.imageUrl = res.data.ImageUrl;
            this.code = res.data.ImgHotspotHTML;
            this.musicFileUrl =  res.data.MusicURL;
            this.musicType = res.data.IsMusicEnable;
            this.mouseCursorType = res.data.IsMouseCursorEnable;
             })
           .catch(err => {          
             console.error(err)
           })
       }, 
       before_save() {
         this.$validator.validateAll().then((result) => {
           if (result) {
             // if form have no errors
             this.save_changes();
           }
         });
       },
       save_changes() {
         this.sendData = [];
         if(this.showValues != null){
              this.sendData.MusicURL = this.musicFileUrl;
              this.sendData.ImgHotspotHTML = this.code;
              this.sendData.musicfile = this.musicFile;
         }else{
               this.sendData.MusicURL = this.musicFileUrl;
                this.sendData.ImgHotspotHTML = this.code;
                 this.sendData.musicfile = this.musicFile;
         }
         console.log("sendData==========",this.sendData);
          this.$vs.loading();
          this.$store
           .dispatch("virtuallobbyManagement/updateVirtuallobbyImageHotspot", {
             data: this.sendData,
           })
           .then((res) => {
             if (res.status == 200) {
                 this.$vs.notify({
                 color: "success",
                 position: "top-center",
                 title: "Virtual Lobby",
                 text: "Updated Successfully!",
               });
               this.$vs.loading.close();
             }
           })
           .catch((err) => {
             this.$vs.loading.close();
           });
       },
       fetch_event_data() {
         let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
         this.$store
           .dispatch("eventManagement/fetchEventMenu", Session_Event_Id)
           .then((res) => {
             res.AvailableMenu.map(row =>{ 
               //this.menuUrls.push(row.PageUrl);
               this.menuUrls.push({key:row.DisplayLabel,value: row.PageUrl});
               })
               this.menuUrls.push({key:'Custom URL',value: 'Custom URL'});
           })
           .catch((err) => {});
       },
           lobbyBgUpload(input, fieldName, fieldsrc) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 1) {
          alert("Uploaded file size exceeds 1 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadFile(bgImgfile, fieldName, fieldsrc);
          this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadFile(file, fieldName, fieldsrc) {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/uploadImage", {
          file: file,
          path: cn + "/Lobby/",
        })
        .then((res) => {
          this.$vs.loading.close();
          this.imageUrl = res;
           this.sendData = [];
 this.sendData.ImageUrl =  this.imageUrl;
 this.$store
  .dispatch("virtuallobbyManagement/updateVirtuallobbyImageHotspot", {
             data: this.sendData,
           })
           .then((res) => {
             this.isImageUploaded = true;
           })
           .catch((err) => {
           });
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
     },
   
     mounted(){
       var array = [];
         $('ul.tabs li').click(function(){
         var tab_id = $(this).attr('data-tab');
   
         $('ul.tabs li').removeClass('current');
         $('.tab-content').removeClass('current');
   
         $(this).addClass('current');
         $("#"+tab_id).addClass('current');
         });
   
   
   $( ".outfit img" ).click(function(e) {   
     if(hotspotFlag == true){
       alert("Please Select Url for the Previous Hotspot and then proceed!!")
     }else{
     var dot_count = $( ".dot" ).length;
     var updateDotVal = dot_count + 1;
     if(hotspotNumber.includes(updateDotVal)){
       console.log("present inside hotspot============")
       var lastVal = hotspotNumber.pop();
      console.log("lastVal============",lastVal);
     }else{
       console.log("not present inside hotspot============")
     }
   
     latestSpotVal = updateDotVal;
     hotspotNumber.push({id:updateDotVal});
     hotspotFlag = true;
     var top_offset = $(this).offset().top - $(window).scrollTop();
     var left_offset = $(this).offset().left - $(window).scrollLeft();
   
     var top_px = Math.round( (e.clientY - top_offset - 12) );
     var left_px = Math.round( (e.clientX - left_offset - 12) );
     
     var top_perc = top_px / $(this).height() * 100;
     var left_perc = left_px / $(this).width() * 100;
     
     var dot = '<div id='+'"'+(dot_count + 1)+'"' + 'class="dot" style="text-align: center; top: ' + top_perc + '%; left: ' + left_perc + '%;">' + (dot_count + 1) + '</div>';
     
     $(dot).hide().appendTo($(this).parent()).fadeIn(350);;
     
     $( ".dot" ).draggable({
       containment: ".outfit",
       stop: function( event, ui ) {
         var new_left_perc = parseInt($(this).css("left")) / ($(".outfit").width() / 100);
         var new_top_perc = parseInt($(this).css("top")) / ($(".outfit").height() / 100);
         var output = 'Top: ' + parseInt(new_top_perc) + '%, Left: ' + parseInt(new_left_perc);
         
         $(this).css("left", parseInt($(this).css("left")) / ($(".outfit").width() / 100) + "%");
         $(this).css("top", parseInt($(this).css("top")) / ($(".outfit").height() / 100) + "%");
         
         $('.output').html('CSS Position1: ' + output);
        //  hotspotNumber.push({left:new_left_perc,top:new_top_perc});
              hotspotNumber.map((row) => {
         if(row.id == latestSpotVal){
           row.left = new_left_perc;
           row.top = new_top_perc;
         }
       });
          console.log("Updated Dot No: "+ (dot_count + 1) + " Left: " + new_left_perc + "; Top: " + new_top_perc + ';');
       }
     });
     
     console.log("Dot No: "+ (dot_count + 1) + " Left: " + left_perc + "%; Top: " + top_perc + '%;');
         console.log("link========",'<a href="/mymeetings" style="position: absolute; left:'+ left_perc +'%;'+ 'top:' + top_perc +'%;"></a>');
        //  hotspotNumber.push({left:left_perc,top:top_perc});

     hotspotNumber.map((row) => {
         if(row.id == latestSpotVal){
           row.left = left_perc;
           row.top = top_perc;
         }
       });

     $('.output').html("CSS Position2: Left: " + parseInt(left_perc) + "%; Top: " + parseInt(top_perc) + '%;');
     }
   
     
   });
       },
       created() {
       if (!moduleVirtualLobbyManagement.isRegistered) {
         this.$store.registerModule("virtuallobbyManagement", moduleVirtualLobbyManagement);
         moduleVirtualLobbyManagement.isRegistered = true;
       }
      if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
       this.fetchVirtualTemplates();
       this.fetch_virtuallobby_data();
       this.fetch_event_data();
     },
   }
   
   
   
</script>